import React, { Component } from "react";
// import AgGridTable from "../../components/common/agGridTable";
import ReadAxios from "../../components/axiosComponent/read";
import { connect } from "react-redux";
import AgGridTable from '../../components/agGridComponent/agGridTable';

import { Formik, Field, Form } from "formik";
import { Button, Modal } from 'semantic-ui-react';

import { isEmpty } from "lodash";

import AxiosRequest from "../../components/axiosComponent/allRequestAxios";

import * as yup from "yup";
import { AllRegex } from "../../utils/validation";
import {
    FIELD_IS_REQUIRED, INVALID_EMAIL,
    INVALID_MOBILE_NO, INVALID_NAME,
    INVALID_PAN_NO, INVALID_PIN_CODE,
    TOAST_MESSAGES
} from "../../config/const";
import { title_bar_title, billingPartyHeaders, fields, buttons, import_title } from './billingPartyConstants'
import { MyInput, MyTextArea } from "../../components/formikInput/input";
import PopupModal from "../../components/UiComponents/popupModal";
import MyCustomerType from "../../components/UiComponents/myCustomerType";
import MyIndustry from "../../components/UiComponents/myIndustry";
import cogoToast from "cogo-toast";
import { FEATURES } from "../../components/utils/constants";

class BillingParty extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowData: [],
            loadingData: true,
            searchChange: false,
            searchValue: '',
        };
    }

    componentDidMount() {
        ReadAxios({ completeURL: `${process.env.REACT_APP_BASE_URL}/masters/billing_party` })
            .then((dataArray) => {
                this.setState({
                    rowData: isEmpty(dataArray) ? [] : dataArray.data.resultSet,
                    loadingData: false,
                });
            })
            .catch((err) => {
                console.log(err);
                this.setState({ loadingData: false, rowData: [] });
            });
    }

    onCellClicked = (rowData) => {
        typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }

    onRowEdit = (rowData) => {
        ReadAxios({
            completeURL: `${process.env.REACT_APP_BASE_URL}/masters/billing_party_type_mapping?billingPartyId=${rowData.billingPartyId}`,
        })
            .then((res) => {
                let values = res.data.resultSet
                values.map((el, i) => {
                    let temp = {}
                    temp.toBeBilled = el.toBeBilled == 1 ? 'toBeBilled' : ''
                    temp.toPay = el.toPay == 1 ? 'toPay' : ''
                    temp.freeOfCost = el.freeOfCost == 1 ? 'freeOfCost' : ''
                    temp.paid = el.paid == 1 ? 'paid' : ''
                    temp.billingPartyId = rowData.billingPartyId || 0
                    rowData.customer_type_id = Object.values(temp)
                })
                this.props.history.push("/add_billing_party", {
                    ...rowData,
                    title: "edit_title",
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    handleSearch = (e, data) => {
        this.setState({
            searchValue: data.value,
        });
    }

    onRowDelete = (alert) => {
        if (alert.type === "success") {
            cogoToast.success(TOAST_MESSAGES.DELETE_SUCCESS).then(() => {
                this.props.history.push("/billingparty");
                this.props.history.go();
            })
        }
        else {
            cogoToast.error(alert.messageBody).then(() => {
                this.props.history.push("/billingparty");
                this.props.history.go();
            })
        }
    };

    render() {
        const { rowData } = this.state;
        const Columns = [
            {
                headerName: billingPartyHeaders.branch_name || "Branch Name",
                field: "billingPartyName",
                sortable: true,
                filter: true,
            },
            {
                headerName: billingPartyHeaders.branch_code || "Code",
                field: "billingPartyCode",
                sortable: true,
                filter: true,
            },
            {
                headerName: billingPartyHeaders.industry || "Industry",
                field: "industrySegmentName",
                sortable: true,
                filter: true,
            },
            {
                headerName: billingPartyHeaders.created_by || "Created By",
                field: "createdByName",
                sortable: true,
                filter: true,
            },
            {
                headerName: billingPartyHeaders.created_on || "Created On",
                field: "createdOn",
                sortable: true,
                filter: true,
            },
            {
                headerName: billingPartyHeaders.modified_by || "Modified By",
                field: "updatedByName",
                sortable: true,
                filter: true,
            },
            {
                headerName: billingPartyHeaders.modified_on || "Modified On",
                field: "updatedOn",
                sortable: true,
                filter: true,
            },
            {
                headerName: billingPartyHeaders.actions || "Edit / Delete",
                field: "edit",
                cellRenderer: "actionRenderer",
                suppressToolPanel: true,
                pinned: "right",
            }
        ];
        const data = {
            validationSchema: yup.object({
                //billingPartyCode: yup.string().required("required"),
                billingPartyName: yup.string().required(FIELD_IS_REQUIRED),
                billingPartyContactPerson: yup.string().required(FIELD_IS_REQUIRED),
                panNumber: yup.string().optional().matches(AllRegex.PANIN, INVALID_PAN_NO),
            })
        }
        const onNewCLick = () => {
            this.props.history.push("/add_billing_party")
            this.props.history.go()
        }
        return (
            <React.Fragment>
                <AgGridTable
                    isLoading={this.state.loadingData}
                    columnDefs={Columns}
                    rowData={rowData}
                    titleBarTitle={title_bar_title}
                    titleBarLink={"/add_billing_party"}
                    baseURL={"billing_party"}
                    pathName={"billingPartyMaster"}
                    fileName={"billingPartyMaster"}
                    newPopup={() => onNewCLick()}
                    keyIndex={"billingPartyId"}
                    onEdit={this.onRowEdit}
                    cellDoubleClicked={this.onCellClicked}
                    onDelete={this.onRowDelete}
                    importTitle={import_title || 'Billing Party'}
                    searchValue={this.state.searchValue}
                    handleSearch={this.handleSearch}
                    exportHidden={FEATURES.mastersExportDisabled()}
                    suppressExcelExport={FEATURES.mastersExportDisabled()}
                    suppressCsvExport={FEATURES.mastersExportDisabled()}
                />

                <PopupModal centered show={this.state.open} handleClose={this.handleClose} Title="Billing Party Edit">
                    <Formik
                        initialValues={{
                            billingPartyCode: this?.state?.rowItems?.billingPartyCode || '',
                            billingPartyName: this?.state?.rowItems?.billingPartyName || '',
                            billingPartyAddress: this?.state?.rowItems?.billingPartyAddress || '',
                            billingPartyContactPersonNumber: this?.state?.rowItems?.billingPartyContactPersonNumber || '',
                            billingPartyContactPerson: this?.state?.rowItems?.billingPartyContactPerson || '',
                            billingPartyPincodeNo: this?.state?.rowItems?.billingPartyPincodeNo || '',
                            industrySegmentId: this?.state?.rowItems?.industrySegmentId || '',
                            creditPeriod: this?.state?.rowItems?.creditPeriod || '',
                            billingPartyId: this?.state?.rowItems?.billingPartyId || '',
                            billingPartyEmail: this?.state?.rowItems?.billingPartyEmail || '',
                            customer_type_id: this?.state?.rowItems?.customer_type_id || '',
                            toBeBilled: this?.state?.rowItems?.toBeBilled || '',
                            toPay: this?.state?.rowItems?.toPay || '',
                            freeOfCost: this?.state?.rowItems?.freeOfCost || '',
                            panNumber: this?.state?.rowItems?.panNumbe || ''
                        }}
                        validationSchema={yup.object({
                            billingPartyName: yup.string().required(FIELD_IS_REQUIRED),
                            billingPartyContactPerson: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Name, INVALID_NAME),
                            panNumber: yup.string().optional().matches(AllRegex.PANIN, INVALID_PAN_NO),
                            billingPartyEmail: yup.string().optional().matches(AllRegex.Email, INVALID_EMAIL),
                            billingPartyContactPersonNumber: yup.string().optional().matches(AllRegex.MobileNumber, INVALID_MOBILE_NO),
                            billingPartyPincodeNo: yup.string().optional(AllRegex.Pincode, INVALID_PIN_CODE),
                        })}
                        onSubmit={(value, { setSubmitting }) => {
                            if (value.customer_type_id.length > 0) {
                                value.customer_type_id.map((element) => {
                                    value[element] = '1'
                                })
                            }
                            AxiosRequest({
                                url: `masters/billing_party/${value.billingPartyId}`,
                                method: 'PATCH',
                                Items: value
                            }).then((response) => {
                                if (response.status === 200) window.location.reload()
                            }).catch((error) => {
                                console.log(error.response.data.message)
                            })

                        }}
                    >
                        {({ values, isSubmitting, touched, errors }) => (
                            <Form className="ui form">
                                <Modal.Body>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label className='labelName'> {fields.billing_party_code.title || "Billing Party Code"} </label>
                                            <Field component={MyInput} name="billingPartyCode" />
                                            {touched.billingPartyCode && errors.billingPartyCode ? <small className="form-text text-muted w3-tiny w3-text-red">{errors.billingPartyCode}</small> : ''}
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <label className='labelName'> {fields.billing_party_name.title || "Billing Party Name"} </label>
                                            <Field component={MyInput} name="billingPartyName" />
                                            {touched.billingPartyName && errors.billingPartyName ? <small className="form-text text-muted w3-tiny w3-text-red">{errors.billingPartyName}</small> : ''}
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <label className='labelName'>{fields.email.title || "Email Id"}</label>
                                            <Field component={MyInput} name="billingPartyEmail" />
                                            {touched.billingPartyEmail && errors.billingPartyEmail ? <small className="form-text text-muted w3-tiny w3-text-red">{errors.billingPartyEmail}</small> : ''}
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <label className='labelName'>{fields.mobile.title || "Mobile No"}</label>
                                            <Field component={MyInput} name="billingPartyContactPersonNumber" />
                                            {touched.billingPartyContactPersonNumber && errors.billingPartyContactPersonNumber ? <small className="form-text text-muted w3-tiny w3-text-red">{errors.billingPartyContactPersonNumber}</small> : ''}
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <label className='labelName'>{fields.address.title || "Address"}</label>
                                            <Field component={MyTextArea} name="billingPartyAddress" />
                                            {touched.billingPartyAddress && errors.billingPartyAddress ? <small className="form-text text-muted w3-tiny w3-text-red">{errors.billingPartyAddress}</small> : ''}
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <label className='labelName'>{fields.pincode.title || "Billing Party Pincode"}</label>
                                            <Field component={MyInput} name="billingPartyPincodeNo" />
                                            {touched.billingPartyPincodeNo && errors.billingPartyPincodeNo ? <small className="form-text text-muted w3-tiny w3-text-red">{errors.billingPartyPincodeNo}</small> : ''}
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <label className='labelName'>{fields.customer_type.title || "Customer Type"}</label>
                                            <Field component={MyCustomerType} multiSelect={true} mode="edit" editId={values.billingPartyId} multiple value={values.customer_type_id} name="customer_type_id" />
                                            {touched.customer_type_id && errors.customer_type_id ? <small className="form-text text-muted w3-tiny w3-text-red">{errors.customer_type_id}</small> : ''}
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <label className='labelName'>{fields.industry.title || "Industry"}</label>
                                            <Field component={MyIndustry} value={values.industrySegmentId} name="industrySegmentId" />
                                            {touched.industrySegmentId && errors.industrySegmentId ? <small className="form-text text-muted w3-tiny w3-text-red">{errors.industrySegmentId}</small> : ''}
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <label className='labelName'>{fields.credit_period.title || "Credit Period"}</label>
                                            <Field component={MyInput} type="number" min="0" name="creditPeriod" />
                                            {touched.creditPeriod && errors.creditPeriod ? <small className="form-text text-muted w3-tiny w3-text-red">{errors.creditPeriod}</small> : ''}
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <label className='labelName'>{fields.contact_person.title || "Contact Person"}</label>
                                            <Field component={MyInput} name="billingPartyContactPerson" />
                                            {touched.billingPartyContactPerson && errors.billingPartyContactPerson ? <small className="form-text text-muted w3-tiny w3-text-red">{errors.billingPartyContactPerson}</small> : ''}
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <label className='labelName'>{fields.pan_number.title || "Pan Number"}</label>
                                            <Field component={MyInput} name="panNumber" />
                                            {touched.panNumber && errors.panNumber ? <small className="form-text text-muted w3-tiny w3-text-red">{errors.panNumber}</small> : ''}
                                        </div>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    {isSubmitting ? "Loading..." : ''}
                                    <Button size="sm" type="button" onClick={this.handleClose} variant="secondary">{buttons.close || "Close"}</Button>
                                    <Button type="submit" size="sm" disabled={isSubmitting} variant="primary">{buttons.save || "Save"}</Button>
                                </Modal.Footer>
                            </Form>
                        )}
                    </Formik>
                </PopupModal>
            </React.Fragment>

        );
    }
}
const mapStateToProps = ({ permissions }) => {
    return {
        permissions,
    }
};

export default connect(
    mapStateToProps
)(BillingParty);
